/**
 * If the status is SAVED_CONFIGURATION_MIGRATION, it is a status related to either the migration of 
 * the user preferences or the saved trade plan templates. If it is a TP template, the configurationName will
 * be that tp's template name. if it is user preference,s it will say: "User Preferences". In the example below,
 * it relates to an error with migrating a saved template.
 * {
	"messageType": "alertNotification",
	"notificationId": 1645457356918,
	"notificationDetails": {"errorType":"SYSTEM_ERROR","notificationType":"ERROR"},
	"status": "SAVED_CONFIGURATION_MIGRATION",
	"statusDetails": {"configurationName":"User Preferences"},
	"date": "2022-02-21T10:29:17.682-0500",
	"timestamp": "1645457357682"
}

 * @param {*} statusDetails 
 * @return an object with fields:
 * 1) configurationName  (either saved template name, or userPreferences for a “User Preferences” migration bug)
 */
export function savedConfigurationMigrationParser(statusDetails) {
  const parsedObj = {
    configurationName: null,
  };
  if (statusDetails) {
    parsedObj.configurationName = statusDetails.configurationName ?? null;
  }
  return parsedObj;
}
